import { store } from 'State/store';

//E.g. useStore('appConfig.routes')
export const useStore = (keyString) =>
  store((state) => {
    if (keyString) {
      return keyString.split('.').reduce((obj, key) => obj[key], state);
    } else {
      return state;
    }
  });
